// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"05042cb8","300":"ae17b7a5","543":"551af4f4","670":"4475b711","678":"a50a46de","703":"bc30c4fd","828":"1f60d958","910":"e65572c7","920":"ee231aa0"}[chunkId] + ".chunk.js";
};